import { getToken } from '@/scripts/token.js';
import constants from '@/constants';
import { axiosRequest, METHOD } from '@/api/default.js';

export async function getProviderAndGamesAxios(isNew = false) {
    const token = await getToken();
    if (token === null) {
        throw 'Authorization token was not detected';
    }

    return {
        method: METHOD.GET,
        url: `${process.env.VUE_APP_BACKEND_URL}${constants.URL.PROVIDER_AND_GAME_GET}`,
        params: {
            filter_by_new_files: isNew,
        },
        headers: {
            Authorization: token,
            'Cache-Control': 'no-cache',
        },
    };
}

export async function getProvidersAxios() {
    const token = await getToken();
    if (token === null) {
        throw 'Authorization token was not detected';
    }

    return {
        method: METHOD.GET,
        url: `${process.env.VUE_APP_BACKEND_URL}${constants.URL.PROVIDER_GET}`,
        params: {
            get_all: true,
            including_no_games: true,
        },
        headers: {
            Authorization: token,
            'Cache-Control': 'no-cache',
        },
    };
}

export async function getProviderAndGames(isNew = false) {
    const response = await axiosRequest({
        url: constants.URL.PROVIDER_AND_GAME_GET,
        method: METHOD.GET,
        requestName: 'GET PROVIDER AND GAME',
        isLoader: false,
        params: {
            filter_by_new_files: isNew,
        },
    });

    return response == null ? [] : response;
}

export async function getProviders() {
    const response = await axiosRequest({
        url: constants.URL.PROVIDER_GET,
        method: METHOD.GET,
        requestName: 'GET PROVIDER',
        isLoader: false,
        params: {
            get_all: true,
            including_no_games: true,
        },
    });

    return response == null ? [] : response;
}

export async function getClassificationProgress() {
    // How many of each provider's images the LLM has described, keyed by provider
    // id. The upload no longer waits for that call, so a freshly uploaded provider
    // shows its images climbing towards the total instead of arriving already
    // described.
    //
    // One request for the whole list, not one per row: the per-row version put 52
    // simultaneous requests on the backend every time the main page opened, and the
    // tail of that burst came back 503. skipErrorPopup for the same reason — this
    // is a progress hint, and a missing hint must not bury the page in red toasts.
    const response = await axiosRequest({
        url: constants.URL.PROVIDER_CLASSIFICATION_PROGRESS_ALL,
        method: METHOD.GET,
        requestName: 'GET CLASSIFICATION PROGRESS',
        isLoader: false,
        skipErrorPopup: true,
    });

    if (Array.isArray(response) === false) return {};

    return Object.fromEntries(
        response.map((row) => [row['provider_id'], row])
    );
}

export async function updateProvider(data) {
    const response = await axiosRequest({
        url: constants.URL.PROVIDER_UPDATE,
        method: METHOD.PUT,
        requestName: 'UPDATE PROVIDER',
        data: data,
    });

    return response == null ? false : true;
}

export async function createProvider(data) {
    const response = await axiosRequest({
        url: constants.URL.PROVIDER_CREATE,
        method: METHOD.POST,
        requestName: 'CREATE PROVIDER',
        data: data,
    });

    return response;
}

export async function deleteProvider(id) {
    const response = await axiosRequest({
        url: constants.URL.PROVIDER_DELETE,
        method: METHOD.DELETE,
        requestName: 'DELETE PROVIDER',
        params: {
            provider_id: id,
        },
    });

    return response == null ? false : true;
}

export async function updateProviderImage(file, providerID) {
    const data = new FormData();
    data.append('icon_file', file, file.name);

    const response = await axiosRequest({
        url: constants.URL.PROVIDER_UPDATE_ICON,
        method: METHOD.PUT,
        requestName: 'UPDATE ICON PROVIDER',
        params: {
            id: providerID,
        },
        data: data,
        isFile: true,
    });

    return response;
}
